import styled, { css } from 'styled-components'

const ValuationBody = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing(5)};
    text-align: center;

    h3 {
      max-width: 24rem;
      margin-top: 0;
      margin-left: auto;
      margin-right: auto;
      font-weight: 500;
      text-align: center;
    }

    p {
      font-size: 1.8rem;
    }

    p:last-of-type {
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`

export default {
  ValuationBody,
}
